export default "__VITE_ASSET__Dr5$InPm__"